import React from 'react';
import Layout from '../../../components/Layout';
import Page from '../../../components/Page';
import fetch from '../../../core/fetch';
import messages from '../../../locale/messages';
import getLandingMessage from '../../landing/getLandingMessage';
import { staticPageSeo } from '../../../helpers/routeSeo';

const query = `query getEditStaticPage ($id: Int!) {
  getEditStaticPage (id: $id) {
      id
      pageName
      content
      metaTitle
      metaDescription
      createdAt
  }
}`;

export default async function action({ store }) {

  const resp = await fetch('/graphql', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query: query,
      variables: { id: 6 },
    }),
    credentials: 'include',
  });

  const { data } = await resp.json();
  const page = data?.getEditStaticPage;
  const { title, description } = staticPageSeo(store, page, {
    title: getLandingMessage(store, messages.batch2CookieMetaTitle),
    description: getLandingMessage(store, messages.batch2CookieMetaDescription),
  });
  const heading = getLandingMessage(store, messages.batch2CookieH1);

  return {
    title,
    description,
    chunk: 'policies',
    component: (
      <Layout>
        <Page html={page?.content} title={heading} />
      </Layout>
    ),
  };

};
